import React from "react";
import PersonalDataContent from "./personaldata/PersonalDataContent";
import PersonalIdentificationContent from "./personaldata/PersonalIdentificationContent";

export default function PersonalData({ userData, handleEvents }) {
  const boxName = "content-personaldata";
  
  return (
    <div id="personaldata-box" className="" style={{ margin: "0 20px" }}>
      <PersonalDataContent
        boxName={boxName}
        userData={userData}
        handleEvents={handleEvents}
      />
      <PersonalIdentificationContent
        boxName={boxName}
        userData={userData}
        handleEvents={handleEvents}
      />
    </div>
  );
}
